import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from './services/storage.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'SGGS';
 showGoTop = false;  

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.showGoTop = window.pageYOffset > 100;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  constructor(translate: TranslateService, private router: Router, private storage: StorageService) {
    let baniLanguage = localStorage.getItem('language');
    if(!baniLanguage){
      localStorage.setItem('language','en');
    }

    if (baniLanguage) {
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(baniLanguage);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(baniLanguage);
    }
    else{
      translate.setDefaultLang('en');

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use('en');
    }
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // const languageKey = this.languageService.getLanguageKey();
        const languageKey = this.storage.get('language');
        if (languageKey === 'pa') {
          // Check if language param already exists
          const url = this.router.url;
          // let thisUrl = this.router.url;
          const isHomeUrl = url === '/' || url === '/home';
          const hasLangInUrl = /\/(english|panjabi)(\/|$)/.test(this.router.url);
          if (!url.includes('lang=pa') && !isHomeUrl && !hasLangInUrl) {
            this.router.navigate([], {
              queryParams: { lang: 'pa' },
              queryParamsHandling: 'merge' // Keeps other params intact
            });
          }
        }
      }
    });
  }
}
